import React from 'react';
import { Header, PageContainer, PageContent, Sidebar } from '../../layouts';
import { Button, InputField, SelectMenu, TitleLarge } from '../../components';
import {
	CHANGE_PASSWORD_ICON,
	RECORD_NUM_OPTIONS,
	SAVE_ICON,
	THEME_OPTIONS,
} from '../../utils/consts';
import { isDarkModeSet, setTheme } from '../../utils/set-theme';
import { useTheme } from '../../hooks/theme-hook';

const SettingsPage = () => {
	const { setIsDarkMode } = useTheme();

	return (
		<>
			<Header />
			<PageContainer>
				<Sidebar />
				<PageContent>
					<TitleLarge>Nikolay Malygin</TitleLarge>
					<div className='container my-3'>
						<div className='row justify-content-center'>
							<div className='col-12 col-sm-8 col-xl-7'>
								<p className='fw-semibold'>Passwort ändern</p>
								<InputField
									id={'password_old'}
									classes={'background-secondary'}
									type={'password'}
									label={'Passwort alt'}
								/>
								<InputField
									id={'password_new'}
									classes={'background-secondary'}
									type={'password'}
									label={'Passwort neu'}
								/>
								<InputField
									id={'password_new_confirm'}
									classes={'background-secondary'}
									type={'password'}
									label={'Passwort neu bestätigen'}
								/>
								<div className='d-flex justify-content-end'>
									<Button
										classes={'background-blue px-4 py-2 rounded-3'}
										icon={CHANGE_PASSWORD_ICON}>
										Passwort ändern
									</Button>
								</div>
							</div>
						</div>
						<div className='row justify-content-center mt-4'>
							<div className='col-12 col-sm-8 col-xl-7'>
								<SelectMenu
									id={'record_num'}
									classes={'background-secondary'}
									label={'Anzahl der Datensätze'}
									options={RECORD_NUM_OPTIONS}
								/>
							</div>
						</div>
						<div className='row justify-content-center'>
							<div className='col-12 col-sm-8 col-xl-7'>
								<SelectMenu
									id={'record_num'}
									classes={'background-secondary'}
									label={'Theme'}
									options={THEME_OPTIONS}
									onChange={(e) => {
										setTheme(e.target.value);
										setIsDarkMode(isDarkModeSet() ? true : false);
									}}
								/>
								<div className='d-flex justify-content-end'>
									<Button
										classes={'background-blue px-4 py-2 rounded-3'}
										icon={SAVE_ICON}>
										Speichern
									</Button>
								</div>
							</div>
						</div>
					</div>
				</PageContent>
			</PageContainer>
		</>
	);
};

export default SettingsPage;
